import { Navigate } from "Navigation/Navigate";
import type {
  AccessRightWithPermissionsDto,
  Permission,
} from "Infrastructure/Api/Api";
import { hasPermission } from "Hooks/usePermission";
import type { AccessRightCode } from "Models/AccessRightCodes";
import { getAppUrl } from "Utils/UrlUtils";
import { type RouteProps, useLocation } from "react-router-dom";

type Props = {
  requiredAccessRight: AccessRightCode;
  userAccessRights: Array<AccessRightWithPermissionsDto>;
  requiredPermission: Permission;
  fallbackUrl?: string;
} & RouteProps;

export const AuthorizedRoute = ({
  requiredAccessRight,
  userAccessRights,
  requiredPermission,
  children,
  fallbackUrl,
}: Props) => {
  const location = useLocation();
  const appUrl = getAppUrl();

  const accessRight = userAccessRights.find(
    (ar) => ar.code === requiredAccessRight,
  );
  const isAuthorized = hasPermission(accessRight, requiredPermission);

  if (!isAuthorized) {
    return (
      <Navigate
        to={fallbackUrl || appUrl("sign-in")}
        state={{ from: location }}
      />
    );
  }

  return children ? <>{children}</> : null;
};
